/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import { ScreenFooterProps } from './ScreenFooterProps';

import './ScreenFooter.scss';

const ScreenFooter: FunctionComponent<ScreenFooterProps> = ({ image, children }): JSX.Element => {
    return (
        <div className="screen-footer-container">
            <div className="left-content">
                <img className={`${image?.imageType}`} src={image?.imageUrl} />
            </div>
            <div className="right-content">{children}</div>
        </div>
    );
};

export default ScreenFooter;
